
import { IKhoActions } from "../../action-types/category/IKhoActionTypes";
import { IKhoReducer } from "../../reducer-model/category/IKhoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IKhoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    khos: []
}
export const khoReducer = (state: IKhoReducer = iniState, action: IKhoActions): IKhoReducer => {
    switch (action.type) {
        case "KHO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "KHO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                khos: action.payload
            }
        case "KHO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "KHO_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                khoEditing: action.payload
            }
        case "KHO_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "KHO_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "KHO_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "KHO_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "KHO_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "KHO_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "KHO_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}